import React from 'react';
import { Box, Fade, FormGroup, Fab } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { useAuth } from './utils/Auth';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'white',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    textAlign: 'center',
};

const acceptableFileTypes = ['pdf', 'jpg', 'jpeg', 'tiff', 'png'];
const MAX_FILE_SIZE = 2097152;

const url = "https://inlinetracking.com/wp-json/inline-tracking/v1/route/records/";

export default function UploadDocuments(props) {

    const { rowID, entryID, openModal = false, setOpenModal, handleCloseModal, files = [], setFiles, updateLocationEvidence } = props;
    const { enqueueSnackbar } = useSnackbar();
    let auth = useAuth();

    const checkFileName = (name) => {
        return acceptableFileTypes.includes(name.split(".").pop().toLowerCase());
    };

    const handleFile = (event) => {
        event.preventDefault();
        const capturedFiles = Array.from(event.target.files);

        if (!capturedFiles) return;

        const filteredFiles = capturedFiles.filter(file => {
            if (file.size === 0) {
                enqueueSnackbar("The file: " + file.name + " is empty and can't be uploaded.", { variant: 'error', autoHideDuration: 6000 })
                return false;
            }
            else if (file.size > MAX_FILE_SIZE) {
                enqueueSnackbar("The size of the file : " + file.name + " is more than 2MB.", { variant: 'error', autoHideDuration: 6000 })
                return false;
            }
            else if (!checkFileName(file.name)) {
                enqueueSnackbar("The file: " + file.name + " is not allowed to upload. Please check file Type.", { variant: 'error', autoHideDuration: 6000 })
                return false;
            }
            else {
                return file;
            }
        }
        );

        const uploaded = [...files];
        filteredFiles.some((file) => {
            if (uploaded.findIndex((f) => f.name === file.name) === -1) {
                uploaded.push(file);
            }
            else {
                console.log("duplicate")
                enqueueSnackbar("The file: " + file.name + " is already selected", { variant: 'error', autoHideDuration: 6000 });
            }
        })

        setFiles(uploaded);
    };

    const uploadFiles = (event) => {
        event.preventDefault();

        const formData = new FormData();
        files.forEach(file => {
            formData.append('files[]', file, file.name);
        })

        let nonce = typeof Window.nonce !== 'undefined' ? Window.nonce : auth.nonce;
        axios.post(url + entryID + "/" + rowID + '/upload-documents', formData, { headers: { "X-WP-Nonce": nonce } })
            .then(response => response.data)
            .then((data) => { console.log("Data: ", data); updateLocationEvidence(rowID, data.fileUrl); enqueueSnackbar('Successfully uploaded the files.', { variant: 'success', autoHideDuration: 4000 }); })
            .catch(error => {
                enqueueSnackbar("Error is encountered  " + error, { variant: 'error' });
            });

        setOpenModal(false);
        setFiles([]);
    }

    return (
        <div>
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="upload-documents"
                aria-describedby="uploading-documents"
            >
                <Fade in={openModal} >
                    <Box sx={style} component="form" >
                        <Typography id="transition-modal-title" variant="h4" component="h2">
                            Upload Documents
                        </Typography>
                        <FormGroup id="transition-modal-description" sx={{ mt: 2, alignItems: 'center' }}>
                            <Typography component={'span'} variant={'body2'}>
                                Click on + button to select the documents
                            </Typography>
                            <Typography component={'span'} variant={'body2'}>
                                Only PDF & Images are allowed (max each file size is 2MB)
                            </Typography>
                            < br />
                            <Fab
                                color="primary" size="small" component="label" aria-label="add">
                                <input
                                    style={{ display: "none" }}
                                    accept={acceptableFileTypes}
                                    multiple
                                    type="file"
                                    onChange={handleFile}
                                />
                                <AddIcon />
                            </Fab>
                            <br />
                            <Typography component={'span'} variant={'body2'}>
                                {files.length} file(s) selected:
                            </Typography>
                            {files.map(file => (
                                <Typography key={file.name} component={'span'} variant={'body2'}>
                                    {file.name}
                                </Typography>
                            ))}

                        </FormGroup>
                        < br />
                        <Button size="large" variant='contained'
                            onClick={handleCloseModal}
                        >
                            Cancel
                        </Button> {' '}
                        <Button
                            size="large" variant='contained'
                            type='submit' onClick={uploadFiles}
                            disabled={files.length === 0}
                        >
                            Upload
                        </Button>
                        <div> <br />
                            <Typography component={'span'} variant={'body2'}>
                                Notes*: Please ensure that the correct files are uploaded as it is not allowing to upload again.
                            </Typography>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </div>
    )
}
